var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['container__tag', _vm.classNameComputada]},[_c('p',{staticStyle:{"margin":"0"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('i',{class:_vm.buttonIcon,attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.closeButtonClick.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }